import { Skeleton } from "components/common"
import PropTypes from "prop-types"

const SkeletonWrapper = ({ children, loading = false, className, style, ...skeletonProps }) => {
  // If not loading, render children normally
  if (!loading) {
    return children
  }

  // Render skeleton with passed props
  return (
    <Skeleton
      className={className}
      active={skeletonProps.active !== undefined ? skeletonProps.active : true}
      {...(style ? style : {})}
      {...skeletonProps}
    />
  )
}

SkeletonWrapper.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
}

SkeletonWrapper.defaultProps = {
  loading: false,
}

export default SkeletonWrapper
